import react from "react";
import "./ImgBox.css";

export default function ImgBox({ ImgSrc, ImgAlt, imgHeight }) {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="ImgBox">
        <img src={ImgSrc} alt={ImgAlt} style={{ height: isMobile ? imgHeight : "" }} />
      </div>
    </>
  );
}
